import PropTypes from 'prop-types'
import './CardRow.scss'

export default function CardRow({
  children,
  className,
  align,
  direction,
  gap,
  justify,
  p,
  wrap,
  style,
  ...props
}) {
  const handleStyle = () => {
    const styleAttr = (style)? style : {}

    return {
      ...((align)? {alignItems: align}: {}),
      ...((direction)? {flexDirection: direction}: {}),
      ...((gap)? {gap: gap}: {}),
      ...((justify)? {justifyContent: justify}: {}),
      ...((p || p === 0)? {padding: p}: {}),
      ...((wrap)? {flexWrap: wrap}: {}),
      ...styleAttr,
    }
  }

  return (
    <div className={`tw-card-row ${className ? className : ''}`} {...props} style={handleStyle()}>
      {children}
    </div>)
}

CardRow.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.element.isRequired,
    PropTypes.node.isRequired
  ]),
  align: PropTypes.string,
  direction: PropTypes.oneOf([
    'column',
    'column-reverse',
    'inherit',
    'initial',
    'row',
    'row-reverse',
    'unset',
  ]),
  gap: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  justify: PropTypes.oneOf([
    'center',
    'end',
    'flex-start',
    'flex-end',
    'inherit',
    'initial',
    'space-between',
    'space-around',
    'space-evenly',
    'start',
    'unset'
  ]),
  p: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  wrap: PropTypes.string,
  className: PropTypes.string
}